import React from 'react';
import Button from '../../../../components/UI/Button';

import css from '../FundingAccount.module.scss';

interface MorganStanleyACHProps {
  fundingSource: string | null;
  setFundingSource: (type: string) => void;
  fee: number;
}

export default function MorganStanleyACH({
  fundingSource,
  setFundingSource,
  fee
}: MorganStanleyACHProps) {
  return (
    <div>
      <p className={css.recommended} data-e2e="recommended">
        Recommended
      </p>
      <div className={css.AddFundingAccountInfo}>
        <div>
          <p
            className={`${css.AddFundingAccountItemHeader} ${css.centerText}`}
            data-e2e="add-plaid-header"
          >
            Add a bank account
          </p>
          <p
            className={`${css.AddFundingAccountItemBody} ${css.centerText}`}
            data-testid="ms-ach-funding-account-text"
          >
            Add your CashPlus checking account manually to waive your ${fee}
            /month fee (use the 13 digit checking account number for funding).
          </p>
        </div>
      </div>
      {fundingSource !== 'ach' && (
        <div className={css.achPrimaryButton}>
          <Button
            data-e2e="add-plaid-button"
            text="Add bank"
            onClick={() => setFundingSource('ach')}
          />
        </div>
      )}
    </div>
  );
}
